// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__HswBA","logo":"styles_logo__YpvBc","text":"styles_text__N60Nd"};